import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const TestCasesStepRunTimeInfo = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      This table shows the runtime data of test case
      steps in the test cases of the selected monitor configuration.
    </Color>
  </Paragraph>

export default TestCasesStepRunTimeInfo
